import { useLogin } from '@energy-stacks/user-access';
import { fleetUserModelNormalizer } from '@energy-stacks/fleet/feature-users-data';

export const FleetUserLogin = () => {
  useLogin(fleetUserModelNormalizer);
  return null;
};
